import { render, staticRenderFns } from "./ManageTariffs.vue?vue&type=template&id=676cb272&"
import script from "./ManageTariffs.vue?vue&type=script&lang=js&"
export * from "./ManageTariffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports